<div
  #valueSelectContainer
  class="value-selector-container"
  [ngStyle]="{ width: setWidth, 'max-width': maxWidth, height: setHeight }"
    [ngClass]="{
        'inline-value-selector': inlineValueSelector,
        'used-in-reports-filter': usedInReportsFilter
    }"
  >
  <div
    tabindex="0"
    class="value-selector-selected-container"
    [ngClass]="{ disabled: disabled }"
    (click)="this.setSelectingValueOptions()"
    (keydown)="keyHandler($event)"
    [attr.aria-controls]="elementId"
    role="listbox"
    >
    <p
      class="value-selector-option currentSelection-p"
      [ngClass]="{ disabled: disabled }"
      >
      {{ getCurrentSelectionName() }}
    </p>
    <mat-icon
      class="value-selector-arrow currentSelection-i"
      [ngClass]="{ disabled: disabled }"
      >arrow_drop_down</mat-icon
      >
    </div>
    @if (showOptions()) {
      <div
        class="value-selector-options"
        [attr.id]="elementId"
        [ngStyle]="maxHeightReturn()"
        [ngClass]="{ goUp: !extendDown, alignOptionsRight: alignOptionsRight }"
        >
        @if (warningMessage) {
          <p
            class="data-label-inline font-size-12px warning-message-container"
            >
            <mat-icon class="warning-icon">warning</mat-icon>
            {{ warningMessage }}
          </p>
        }
        @for (option of valueList; track option; let i = $index) {
          <p
            class="value-selector-option"
            [ngClass]="{ 'selected-option': option.id === selectedID }"
            (click)="setCurrentSelection(option, i, false)"
            >
            <span>{{ option?.value }}</span>
          </p>
        }
      </div>
    }
  </div>
